// extracted by mini-css-extract-plugin
export default {"message_container":"ErrorBoundary_message_container__o1pHT","text":"ErrorBoundary_text__nPim1"};